import { Button } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const UnitToggleSegment: FunctionComponent<Props> = ({
    className = '',
    isSelected,
    label,
    onSelect,
    testId = TEST_ID,
    unit
}) => {
    const selectedClass = isSelected ? styles.selected : '';

    const handleClick = () => onSelect({ unit });

    return (
        <Button
            className={`${styles.unitToggleSegment} ${selectedClass} ${className}`}
            onClick={handleClick}
            testId={testId}
            text={label}
        />
    );
};

export default UnitToggleSegment;
